self.onmessage = function handleMessageFromMain(msg) {

  var ret = "";
  var ret2 = "";
  
  if (msg.data.islog !== false) {
      try {
        var orderupds = JSON.parse(msg.data.islog.orderupdates);
        ret = (orderupds ? orderupds[msg.data.purchaseorderid][msg.data.productrow-1] : '');
      } catch(e) { }
  }
  var gorders2 = [];
  Object.values(msg.data.gorders).forEach((order,k) => {
    if (order.purchaseorder_id == msg.data.purchaseorderid) {
    if (order.products) {
      gorders2.push(order);
    }
  }
  });
  
  gorders2.forEach(function(order,k) {
    var op = JSON.parse(order.products);
    Object.values(op).forEach((opr,productkey) => {
      if (opr.qty_ordered && opr.projected_delivery) {
        //var projectedtest = moment(opr.projected_delivery, 'YYYY-MM-DD').utc().local().format('YYYYMMDD');
        var projectedtest = opr.projected_delivery.replace('-','').replace('-','').replace('-','');
        if (projectedtest == msg.data.dday) {        
          if (msg.data.productrow == productkey+1) {
            ret2 = opr.qty_ordered;
          }
        } else { }
      } else { }
    })
  });
  
  
  if (msg.data.islog !== false) {
      try {
        var orderupds = JSON.parse((msg.data.islog.orderupdates)).ordersAdd;
        ret2 = orderupds[msg.data.purchaseorderid][msg.data.productrow-1];
      } catch(e) {  }
  }
  
  if (ret == null) { ret = ''; }
  if (ret2 == null) { ret2 = ''; }
  var a = "<span class='inv-daylog-day-sum'><span class='received-value'>" + ret + "</span>&nbsp;<span class='slice'>/</span>&nbsp;<span class='projected-value'>" + ret2 + "</span></span>";
  var acommand = "document.querySelector('#inv-delt-" + msg.data.purchaseorderid + '-' + msg.data.productrow + '-' + msg.data.dday + "').innerHTML = " + '"' + a + '";';
  self.postMessage(acommand);

};